import { Route, Routes, Navigate } from 'react-router-dom';

import { Login } from './Login';
import { Register } from './Register';
import { ForgotPassword } from './ForgotPassword';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="register" element={<Register />} />
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
};
